// Client wrapper for the transactional SMS endpoint (spec §7quater Phase 1).
//
// Fire-and-forget from the UI: we never block the user's flow on Twilio.
// The Netlify Fn re-validates admin OR client auth, re-reads the order
// server-side, and enforces opt-out + idempotency.

import { supabase } from './supabase'

/**
 * @param {string} orderId
 * @param {'pickup_confirmed' | 'invoice_sent' | 'delivered'} smsType
 * @returns {Promise<{ ok?: boolean; skipped?: string; error?: string; twilio_sid?: string }>}
 */
export async function sendSms(orderId, smsType) {
  if (!orderId || !smsType) return { error: 'missing_params' }
  try {
    const { data: sessionData } = await supabase.auth.getSession()
    const token = sessionData?.session?.access_token
    if (!token) return { error: 'not_signed_in' }
    const res = await fetch('/.netlify/functions/send-sms', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ order_id: orderId, sms_type: smsType }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      // eslint-disable-next-line no-console
      console.warn(`[sms:${smsType}]`, res.status, data)
    }
    return data || {}
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[sms:${smsType}] fetch failed`, err?.message || err)
    return { error: err?.message || 'network' }
  }
}
